import { render, staticRenderFns } from "./BeforeLogin.vue?vue&type=template&id=72f9227a&scoped=true"
import script from "./BeforeLogin.vue?vue&type=script&lang=js"
export * from "./BeforeLogin.vue?vue&type=script&lang=js"
import style0 from "./BeforeLogin.vue?vue&type=style&index=0&id=72f9227a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9227a",
  null
  
)

export default component.exports